import { render, staticRenderFns } from "./ProfileSaveModal.vue?vue&type=template&id=f4868174"
import script from "./ProfileSaveModal.vue?vue&type=script&lang=js"
export * from "./ProfileSaveModal.vue?vue&type=script&lang=js"
import style0 from "./ProfileSaveModal.vue?vue&type=style&index=0&id=f4868174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports